function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import c from 'classnames';
import { useSearchBox } from 'react-instantsearch-core';
import SearchBarBase from './Base';
const SearchBar = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    className,
    onSubmit,
    ...restProps
  } = props;
  const {
    query,
    refine
  } = useSearchBox();
  const classNames = c('Searchkit__SearchBar', className);
  return /*#__PURE__*/React.createElement(SearchBarBase, _extends({}, restProps, {
    ref: ref,
    initialQuery: query,
    className: classNames,
    onSubmit: searchQuery => {
      refine(searchQuery);
      if (onSubmit) {
        onSubmit(searchQuery);
      }
    }
  }));
});
export default SearchBar;